import React from 'react';
import {MdCurrencyExchange} from 'react-icons/md';
import StatusButton from 'shared/components/status-button';
import List from 'shared/layout/list';
import useProjection from 'shared/migration-hooks/use-projection';
import toBrl from 'shared/util/to-brl';
import {GiPayMoney, GiReceiveMoney} from 'react-icons/gi';
import {DeliveryManBillingProps} from 'modules/delivery-man-billings/types';
import deliveryManBillingsKeys from 'modules/delivery-man-billings/util/delivery-man-billings-keys';
import dateFnsService from 'shared/services/date-fns-service';
import {Operators} from 'shared/migration-components/filter-list/types';

const Billings: React.FC = () => {
  const projection = useProjection<DeliveryManBillingProps>(
    'deliveryManBillings',
    [
      'id',
      'deliveryMan.name',
      'startDate',
      'endDate',
      'city.name',
      'deliveries',
      'deliveryManFee',
      'occurrences',
      'paid',
      'isClosed',
    ],
    {
      defaultFilters: {
        isClosed: {operator: Operators.Equals, value: true},
        paid: {operator: Operators.Equals, value: false},
      },
    },
  );

  return (
    <List<DeliveryManBillingProps>
      {...{
        titleBar: {
          title: 'Faturas (Entregadores)',
        },
        analyticsCards: [
          {
            field: 'total',
            label: 'Total vendido',
            icon: <MdCurrencyExchange />,
            customValue: toBrl,
          },
          {
            field: 'deliveries',
            label: 'Taxa de entrega',
            icon: <GiReceiveMoney />,
            customValue: toBrl,
          },
          {
            field: 'deliveryManFee',
            label: 'Taxa do entregador',
            icon: <GiPayMoney />,
            customValue: toBrl,
          },
        ],
        table: {
          url: '/delivery-man-billings',
          projection: {
            ...projection,
            options: [
              'deliveryMan.name',
              'city.name',
              {
                value: 'startDate',
                column: (row) => dateFnsService.dateTimeFormat(row.startDate),
              },
              {
                value: 'endDate',
                column: (row) => dateFnsService.dateTimeFormat(row.endDate),
              },
              {
                value: 'deliveries',
                column: (row) => toBrl(row.deliveries),
              },
              {
                value: 'deliveryManFee',
                column: (row) => toBrl(row.deliveryManFee),
              },
              {value: 'occurrences', column: (row) => toBrl(row.occurrences)},
              {
                value: 'paid',
                column: (row) => (
                  <StatusButton
                    text={row.paid ? 'Sim' : 'Não'}
                    variant={row.paid ? 'success' : 'error'}
                  />
                ),
                filter: {
                  type: 'select',
                  values: [
                    {label: 'Sim', value: true},
                    {label: 'Não', value: false},
                  ],
                },
              },
              {
                value: 'isClosed',
                column: (row) => (
                  <StatusButton
                    text={row.isClosed ? 'Sim' : 'Não'}
                    variant={row.isClosed ? 'success' : 'error'}
                  />
                ),
                filter: {
                  type: 'select',
                  values: [
                    {label: 'Sim', value: true},
                    {label: 'Não', value: false},
                  ],
                },
              },
              'deliveryMan.pixKey',
            ],
          },
          translatedPropsKey: 'DeliveryManBillingProps',
        },
        queryKey: deliveryManBillingsKeys.list(),
      }}
    />
  );
};

export default Billings;
